// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, func, string } from 'prop-types'
import antennaIcon from 'images/antenna-icon-orange.png'

const triggerStyles = {
  height: 18,
  width: 18,
}

const AdditionalTrigger = props => {
  const {
    columnKey,
    additional,
    idRoot,
    TooltipTrigger,
  } = props

  // if there are no additional antennas, then don't display the tooltip trigger
  if (!additional.length) {
    return null
  }

  return (
    <TooltipTrigger
      idRoot={idRoot}
      tooltipColumn={columnKey}
      tooltipData={additional}>
      <img
        src={antennaIcon}
        style={triggerStyles} />
    </TooltipTrigger>
  )
}

AdditionalTrigger.propTypes = {
  additional: array.isRequired,
  columnKey: string.isRequired,
  idRoot: string.isRequired,
  TooltipTrigger: func.isRequired,
}

export default AdditionalTrigger
